var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-trap",on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab"))return null;return _vm.trapTab($event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }